import React from 'react';
import type { DashboardStats } from '../../models/DashboardStats';
import { DemandSourceWidget } from '../DemandSource';
import { NoShowsWidget } from '../NoShows';
import { UserRankingWidget } from '../UserRanking';
import { FailureReasonsWidget } from '../FailureReasons';
import { HourlyHeatmap } from '../HourlyHeatmap';

interface DashboardLayoutDefaultProps {
  data: DashboardStats;
  showFailureReasons: boolean;
}

export const DashboardLayoutDefault: React.FC<DashboardLayoutDefaultProps> = ({
  data,
  showFailureReasons,
}) => (
  <>
    <div className='lg:col-span-1'>
      <DemandSourceWidget data={data.demandSource} />
    </div>

    <div className='lg:col-span-1'>
      <NoShowsWidget data={data.noShows} />
    </div>

    <div className='lg:col-span-1'>
      <UserRankingWidget data={data.usersRanking} />
    </div>

    {showFailureReasons && (
      <div className='lg:col-span-1'>
        <FailureReasonsWidget data={data.failureReasons} />
      </div>
    )}

    <div className='md:col-span-2 lg:col-span-2 min-h-[300px]'>
      <HourlyHeatmap data={data.heatmap} />
    </div>
  </>
);
